import { render } from "./ResultadosImportacao.vue?vue&type=template&id=f16a8162"
import script from "./ResultadosImportacao.vue?vue&type=script&lang=js"
export * from "./ResultadosImportacao.vue?vue&type=script&lang=js"
script.render = render

export default script